export const HendlerErrors = (errors) => {

    const ObjectErrors = {};

    errors.forEach(obj => {
        ObjectErrors[obj.field] = obj.message;
    })

    return ObjectErrors;
}